import Link from 'next/link';
import { FC } from 'react';
import { Image } from 'atoms/Image/Image';
import { getSocialNetworkFromUrl } from 'organisms/Footer/SocialLinks/utils';
import { gtmPushSocialClick } from 'modules/gtm/modules/sections/footer/social';
import { useSiteConfig } from 'modules/shop/siteConfig/hooks';
import styles from './styles.module.css';

export const SocialLinks: FC = () => {
  const { footer } = useSiteConfig();

  return !footer?.social_links ? null : (
    <ul className={styles.list}>
      {footer.social_links.map(({ image, parameters, _uid }) => {
        const socialNetwork = getSocialNetworkFromUrl(parameters?.url || '');

        return (
          <li key={_uid} className={styles.item}>
            <Link
              href={parameters?.url}
              target={parameters?.target}
              className={styles.link}
              onClick={() => {
                gtmPushSocialClick(socialNetwork, parameters?.url || '');
              }}
            >
              <Image
                src={image?.filename}
                className={styles.image}
                alt={image?.alt}
              />
            </Link>
          </li>
        );
      })}
    </ul>
  );
};
